import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Autocomplete,
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  isValidArray,
} from "src/helper/publicFunction";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  DeleteClientOrders,
  GetClientOrders,
  GetClientOrderEmails,
} from "./actions";
import { GetCourses } from "../courses/actions";

const ClientOrders = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
  const [courses, setCourses] = useState([]);
  const [courseFilter, setCourseFilter] = useState("");
  // email options come from the get-emails endpoint; selection sets the filter
  const [emails, setEmails] = useState([]);
  const [clientEmailFilter, setClientEmailFilter] = useState("");
  // the client id filter keeps a raw input value and a debounced one for the api
  const [clientIdInput, setClientIdInput] = useState("");
  const [clientIdFilter, setClientIdFilter] = useState("");
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetClientOrders({
        page,
        rowsPerPage,
        search,
        clientId: clientIdFilter,
        clientEmail: clientEmailFilter,
        courseId: courseFilter,
        fetchAll: !!(paymentStatusFilter && paymentStatusFilter !== "ALL"),
        callback: (data) => {
          if (isValidArray(data?.data)) {
            let items = data.data.map((item) => ({
              ...item,
              course_name: item.course?.name ?? "-",
            }));
            if (paymentStatusFilter && paymentStatusFilter !== "ALL") {
              items = items.filter(
                (item) => item.payment_status === paymentStatusFilter
              );
            }
            setData(items);
            setTotalData(
              paymentStatusFilter && paymentStatusFilter !== "ALL"
                ? items.length
                : data?.count ?? 0
            );
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
  };

  // the course and email lists only feed the filter dropdowns, fetched once
  useEffect(() => {
    dispatch(
      GetCourses({
        page: 0,
        rowsPerPage: 500,
        callback: (data) => {
          setCourses(isValidArray(data?.data) ? data.data : []);
        },
      })
    );
    dispatch(
      GetClientOrderEmails({
        callback: (data) => {
          setEmails(isValidArray(data?.data) ? data.data : []);
        },
      })
    );
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setClientIdFilter(clientIdInput.trim());
      setPage(0);
    }, 700);
    return () => clearTimeout(timeout);
  }, [clientIdInput]);

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [
    page,
    rowsPerPage,
    search,
    paymentStatusFilter,
    courseFilter,
    clientIdFilter,
    clientEmailFilter,
  ]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "client_name" },
    { type: columntype.text, name: "client_email" },
    { type: columntype.text, name: "client_phone" },
    { type: columntype.text, name: "order_price" },
    { type: columntype.text, name: "course_name" },
    { type: columntype.text, name: "payment_status" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: false,
    },
    {
      id: "client_name",
      numeric: false,
      disablePadding: false,
      label: "Client Name",
      withSort: false,
    },
    {
      id: "client_email",
      numeric: false,
      disablePadding: false,
      label: "Client Email",
      withSort: false,
    },
    {
      id: "client_phone",
      numeric: false,
      disablePadding: false,
      label: "Client Phone",
      withSort: false,
    },
    {
      id: "order_price",
      numeric: false,
      disablePadding: false,
      label: "Order Amount",
      withSort: false,
    },
    {
      id: "course_name",
      numeric: false,
      disablePadding: false,
      label: "Course",
      withSort: false,
    },
    {
      id: "payment_status",
      numeric: false,
      disablePadding: false,
      label: "Payment Status",
      withSort: false,
    },
    // (dataPrivileges["21"]?.access_edit == 1 ||
    //   dataPrivileges["21"]?.access_delete == 1) && {
    //   id: "action",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Action",
    //   withSort: false,
    // },
  ];

  const List = [
    dataPrivileges["21"]?.access_delete === 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.title ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteClientOrders({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }
      },
    },

  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        GetClientOrders({
          rowsPerPage,
          page: 0,
          search: value,
          clientId: clientIdFilter,
          clientEmail: clientEmailFilter,
          courseId: courseFilter,
          fetchAll: true,
          callback: (data) => {
            if (data) {
              let items = (data?.data ?? []).map((item) => ({
                ...item,
                course_name: item.course?.name ?? "-",
              }));
              if (paymentStatusFilter && paymentStatusFilter !== "ALL") {
                items = items.filter(
                  (item) => item.payment_status === paymentStatusFilter
                );
              }
              setData(items);
              setTotalData(
                paymentStatusFilter && paymentStatusFilter !== "ALL"
                  ? items.length
                  : data?.count ?? items.length
              );
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <Box
        sx={{
          width: "98%",
          marginLeft: "17px",
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "flex-end",
        }}
      >
        <Box sx={{ flex: "1 1 220px" }}>
          <CustomFormLabel>Workshop / Program</CustomFormLabel>
          <Select
            style={{ width: "100%" }}
            value={courseFilter}
            displayEmpty
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 300 },
              },
            }}
            onChange={(event) => {
              setCourseFilter(event.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="">All</MenuItem>
            {courses.map((course) => (
              <MenuItem key={course?.id} value={course?.id}>
                {course?.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box sx={{ flex: "1 1 260px" }}>
          <CustomFormLabel>Client Email</CustomFormLabel>
          <Autocomplete
            options={emails}
            value={clientEmailFilter || null}
            onChange={(event, newValue) => {
              setClientEmailFilter(newValue || "");
              setPage(0);
            }}
            noOptionsText="No emails"
            renderInput={(params) => (
              <TextField {...params} placeholder="Select email" />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 140px" }}>
          <CustomFormLabel>Client ID</CustomFormLabel>
          <CustomTextField
            fullWidth
            placeholder="e.g. 8722"
            value={clientIdInput}
            onChange={(event) =>
              setClientIdInput(event.target.value.replace(/[^0-9]/g, ""))
            }
          />
        </Box>
        <Box sx={{ flex: "1 1 180px" }}>
          <CustomFormLabel>Payment Status</CustomFormLabel>
          <Select
            style={{ width: "100%" }}
            value={paymentStatusFilter}
            displayEmpty
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 200 },
              },
            }}
            onChange={(event) => {
              setPaymentStatusFilter(event.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="PAID">PAID</MenuItem>
            <MenuItem value="FAILED">FAILED</MenuItem>
            <MenuItem value="INITIALIZED">INITIALIZED</MenuItem>
          </Select>
        </Box>
        <Button
          variant="outlined"
          sx={{ height: "40px" }}
          disabled={
            !courseFilter &&
            !clientEmailFilter &&
            !clientIdInput &&
            !paymentStatusFilter
          }
          onClick={() => {
            setCourseFilter("");
            setClientEmailFilter("");
            setClientIdInput("");
            setPaymentStatusFilter("");
            setPage(0);
          }}
        >
          Clear filters
        </Button>
      </Box>
      <DynamicTable
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(id) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteClientOrders({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: id,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => { }} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch

        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={false}
        withDeleteItem={false}
        withEditItem={false}
        withPagination={true}
        withSearch={true}
      />

    </>
  );
};

export default ClientOrders;
